// extracted by mini-css-extract-plugin
export default {"hr-dotted":"horizontalRule_hr-dotted__IiwRA","hr-pale":"horizontalRule_hr-pale__JUnDl"};